var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"请输入和编辑人员的沟通内容"},model:{value:(_vm.feedback),callback:function ($$v) {_vm.feedback=$$v},expression:"feedback"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }